import axios from "axios"
import { authHeader, baseUrl } from "../../utils"
import { CREATE_INVOICE, CREATE_INVOICE_ASSIGNMENT, CREATING_INVOICE, CREATING_INVOICE_ASSIGNMENT, GET_INVOICE_ASSIGNMENTS, GET_INVOICES, GETTING_INVOICE_ASSIGNMENTS, GETTING_INVOICES, INVOICES_ERROR, UPDATE_INVOICE, UPDATING_INVOICE } from "../types"

export const createInvoice = (invoicePayload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: CREATING_INVOICE,
            payload: true
        })

        const response = await axios.post(`${baseUrl}/invoices`, invoicePayload, { headers })
        
        dispatch({
            type: CREATE_INVOICE,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: INVOICES_ERROR,
            error
        })
    }
}

export const updateInvoice = (invoiceId, payload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: UPDATING_INVOICE,
            payload: invoiceId
        })
        const response = await axios.patch(`${baseUrl}/invoices/${invoiceId}`, payload, { headers })
        
        dispatch({
            type: UPDATE_INVOICE,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: INVOICES_ERROR,
            error
        })
    }
}

export const fetchInvoices = (filterString, page, perPage) => async (dispatch) => {    
    try{
        const headers = authHeader()

        let url = `${baseUrl}/invoices?expand=fees.fee`
        if(filterString && filterString !== '') {
            url += `${url.includes('?') ? '&' : '?'}${filterString}`
        }

        if(page > -1 && page!=='') {
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }

        if(perPage > -1 && perPage!=='') {
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch( {
            type: GETTING_INVOICES,
            payload: true
        })

        const response = await axios.get(url, { headers })

        dispatch({
            type: GET_INVOICES,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: INVOICES_ERROR,
            error
        })
    }
}

export const createInvoiceAssignment = (payload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: CREATING_INVOICE_ASSIGNMENT,
            payload: true
        })

        const response = await axios.post(`${baseUrl}/invoice-assignments`, payload, { headers })
        
        dispatch({
            type: CREATE_INVOICE_ASSIGNMENT,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: INVOICES_ERROR,
            error
        })
    }
}

export const fetchInvoiceAssignments = (filterString, page, perPage) => async (dispatch) => {    
    dispatch({
        type: GET_INVOICE_ASSIGNMENTS,
        payload: []
    })
    setTimeout(async() => {
        try{
            const headers = authHeader()
    
            let url = `${baseUrl}/invoice-assignments?expand=student,parent,invoice,sundry.transactions`
            if(filterString && filterString !== '') {
                url += `${url.includes('?') ? '&' : '?'}${filterString}`
            }
    
            if(page > -1 && page!=='') {
                url += `${url.includes('?') ? '&' : '?'}page=${page}`
            }
    
            if(perPage > -1 && perPage!=='') {
                url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
            }
    
            dispatch( {
                type: GETTING_INVOICE_ASSIGNMENTS,
                payload: true
            })
    
            const response = await axios.get(url, { headers })
    
            dispatch({
                type: GET_INVOICE_ASSIGNMENTS,
                payload: response.data.data
            })
            
        }
        catch(error){
            dispatch( {
                type: INVOICES_ERROR,
                error
            })
        }
    }, 200);
}

export const clearCreatedInvoice = () => async (dispatch) => { 
    dispatch({
        type: CREATE_INVOICE,
        payload: null
    })
}

export const clearCreatedInvoiceAssignment = () => async (dispatch) => { 
    dispatch({
        type: CREATE_INVOICE_ASSIGNMENT,
        payload: null
    })
}

export const clearUpdatedInvoice = () => async (dispatch) => { 
    dispatch({
        type: UPDATE_INVOICE,
        payload: null
    })
}